import { WMRateScheduleHeaderLookupLayout, WMItemDpLookupLayout, } from '../../../common/lookups/Layouts/WMLayouts';
import { IDCustomerWithQuickAddLookupLayout, IDCustomerLookupLayout, IDBuyerLookupLayout, IDConsigneeLookupLayout, IDManufacturerLookupLayout, WarantyCodesLookupLayout, IDCodesLookupLayout, IDParticipantLookupLayout } from '../../../common/lookups/Layouts/IdLayouts';
import { EDLookupLayout, EDHazardousLayout } from '../../../common/lookups/Layouts/EDLayouts';
import { ABPopupMessageLayout } from '../../../common/lookups/Layouts/ABLayouts';
import { CAJobLayout } from '../../../common/lookups/Layouts/CALayouts';
import { ACDepartmentLayout } from '../../../common/lookups/Layouts/ACLayouts';
import { FAFundLayout } from '../../../common/lookups/Layouts/FALayouts';
import { IDWarehouseLookupLayout } from '../../../common/lookups/Layouts/IdLayouts';
//import Form from "../../components/quickadd/customer/Form";
import MainTab from '../../../id/codes/customerDataEntry/MainTab';
import { CodeLookupLayout, ContainerLookupLayout, IMFeesLookupLayout, ImItemLookupLayout, IMKitHeaderLookupLayout, IMLocationLookupLayout, IMProductCategoryLookupLayout, ItemDpLookupLayout, ItemGroupLookupLayout, MandateFeesLookupLayout, PriceCodesHeaderLookupLayout } from '../../../common/lookups/Layouts/ImLayouts';
import { IM } from '../../../const/constants';

const customerLayout = IDCustomerWithQuickAddLookupLayout({
    onCustomItemCreatingComponent: MainTab,
    IdType: "01",
    // onCustomItemCreatingQuickComponent: Form, 
});
const classCodes = CodeLookupLayout({ codeType: '01' });
const subClassCodes = CodeLookupLayout({ codeType: '02' });
const physicalCountCodes = CodeLookupLayout({ codeType: '07' });
const receiptCodes = CodeLookupLayout({ codeType: '30' });
const shipmentCodes = CodeLookupLayout({ codeType: '31' });
const edHazardousLayout = EDHazardousLayout();
const eDLookupLayout = EDLookupLayout({ Dataelementnum: '355', Versionid: '4010' });
const freightClassCodes = CodeLookupLayout({ codeType: '33' });
const holdReasonCodes = CodeLookupLayout({ codeType: '02' });
const popupMessageLayout = ABPopupMessageLayout({ tableName: 'IMITEM' });
const runtimeParameter = JSON.stringify([
    { RATESELECTION: 'RATESELECTION' },
    { R_IDENTITY: 'R_IDENTITY' },
    { CLASSCODE: 'CLASSCODE' },
    { SUBCLASSCODE: 'SUBCLASSCODE' },
    { R_PROFILE: 'R_PROFILE' },
    { RWarehouse: 'RWarehouse' }
]);
const ratescheduleCodes = WMRateScheduleHeaderLookupLayout({
    status: 'A', type: "I",
    runtimeParameter
});

const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "RECORD",
                "tableName": "IMITEM",
                "localizedField": "Keysequence",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STATUS",
                "tableName": "IMITEM",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "WHID",
                "tableName": "IMITEM",
                "label": "Warehouse",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Description1",
                "tableName": "IMITEM",
                "label": "Description 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 3,
        "fields": [
            {
                "name": "ITEMCODE",
                "tableName": "IMITEM",
                "label": "Item",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PROFILECODE",
                "tableName": "IMITEMDP",
                "label": "Profile",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }


        ]
    },
    {
        "groupId": 4,
        "fields": [{
            "name": "CLASSCODE",
            "tableName": "IMITEM",
            "label": "Class",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "SUBCLASSCODE",
            "tableName": "IMITEM",
            "label": "Sub Class",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "CreationDateTime",
            "tableName": "IMITEM",
            "label": "Creation Date Time",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "CreationUserId",
            "tableName": "IMITEM",
            "label": "Creation User Id",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LastUpdateDateTime",
            "tableName": "IMITEM",
            "label": "Last Update Date Time",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LastUpdateUserId",
            "tableName": "IMITEM",
            "label": "Last Update User Id",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "CompanyId",
            "tableName": "IMITEM",
            "label": "Company Id",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "Module",
            "tableName": "IMITEM",
            "label": "Module",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RecordType",
            "tableName": "IMITEM",
            "label": "Record Type",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },


        {
            "name": "Description2",
            "tableName": "IMITEM",
            "label": "Description2",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "IdentityId",
            "tableName": "IMITEM",
            "label": "Identity Id",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "OemManufacturerCode",
            "tableName": "IMITEM",
            "label": "Oem Manufacturer Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ItemType",
            "tableName": "IMITEM",
            "label": "Item Type",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "AbcCode",
            "tableName": "IMITEM",
            "label": "Abc Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "Status",
            "tableName": "IMITEM",
            "label": "Status",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "StatusReasonCode",
            "tableName": "IMITEM",
            "label": "Status Reason Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "TaxStatus",
            "tableName": "IMITEM",
            "label": "Tax Status",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "Comment",
            "tableName": "IMITEM",
            "label": "Comment",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LocationType",
            "tableName": "IMITEM",
            "label": "Location Type",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PhysicalCountCode",
            "tableName": "IMITEM",
            "label": "Physical Count Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "FreightClassCode",
            "tableName": "IMITEM",
            "label": "Freight Class Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "InventoryUnitUom",
            "tableName": "IMITEM",
            "label": "Inventory Unit Uom",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PiecesPerUnitUom",
            "tableName": "IMITEM",
            "label": "Pieces Per Unit Uom",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PiecesPerUnitQuantity",
            "tableName": "IMITEM",
            "label": "Pieces Per Unit Quantity",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UnitsPerPackageUom",
            "tableName": "IMITEM",
            "label": "Units Per Package Uom",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RItemKittCode",
            "tableName": "IMITEM",
            "label": "RItem Kitt Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UnitsPerPackageQuantity",
            "tableName": "IMITEM",
            "label": "Units Per Package Quantity",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ArTradeDiscountFlag",
            "tableName": "IMITEM",
            "label": "Ar Trade Discount Flag",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PackagesPerShippingUnitUom",
            "tableName": "IMITEM",
            "label": "Packages Per Shipping Unit Uom",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ArTermsDiscountFlag",
            "tableName": "IMITEM",
            "label": "Ar Terms Discount Flag",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PackagesPerShippingUnitQty",
            "tableName": "IMITEM",
            "label": "Packages Per Shipping Unit Qty",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "SaleIncrementQuantity",
            "tableName": "IMITEM",
            "label": "Sale Increment Quantity",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UnitVolumeUom",
            "tableName": "IMITEM",
            "label": "Unit Volume Uom",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "MinimumSalesQuantity",
            "tableName": "IMITEM",
            "label": "Minimum Sales Quantity",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UnitVolumeQuantity",
            "tableName": "IMITEM",
            "label": "Unit Volume Quantity",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedComment",
            "tableName": "IMITEM",
            "label": "User Defined Comment",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UnitAreaUom",
            "tableName": "IMITEM",
            "label": "Unit Area Uom",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UnitAreaQuantity",
            "tableName": "IMITEM",
            "label": "Unit Area Quantity",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UnitValueUom",
            "tableName": "IMITEM",
            "label": "Unit Value Uom",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UnitValueQuantity",
            "tableName": "IMITEM",
            "label": "Unit Value Quantity",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "WeightBasisFlag",
            "tableName": "IMITEM",
            "label": "Weight Basis Flag",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "NetWeightUom",
            "tableName": "IMITEM",
            "label": "Net Weight Uom",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "NetWeightQuantity",
            "tableName": "IMITEM",
            "label": "Net Weight Quantity",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "GrossWeightUom",
            "tableName": "IMITEM",
            "label": "Gross Weight Uom",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RProductCategory",
            "tableName": "IMITEM",
            "label": "RProduct Category",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "GrossWeightQuantity",
            "tableName": "IMITEM",
            "label": "Gross Weight Quantity",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "VendorItemCode",
            "tableName": "IMITEM",
            "label": "Vendor Item Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ReceiptUomDefault",
            "tableName": "IMITEM",
            "label": "Receipt Uom Default",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ReceiptUomMultiple",
            "tableName": "IMITEM",
            "label": "Receipt Uom Multiple",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ReceiptUomAlternative",
            "tableName": "IMITEM",
            "label": "Receipt Uom Alternative",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ReceiptPackSize",
            "tableName": "IMITEM",
            "label": "Receipt Pack Size",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ShipmentUomDefault",
            "tableName": "IMITEM",
            "label": "Shipment Uom Default",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ShipmentUomMultiple",
            "tableName": "IMITEM",
            "label": "Shipment Uom Multiple",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ShipmentUomAlternative",
            "tableName": "IMITEM",
            "label": "Shipment Uom Alternative",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ShipmentPackSize",
            "tableName": "IMITEM",
            "label": "Shipment Pack Size",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ShipSelection",
            "tableName": "IMITEM",
            "label": "Ship Selection",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "StackHeight",
            "tableName": "IMITEM",
            "label": "Stack Height",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PalletPatternRow",
            "tableName": "IMITEM",
            "label": "Pallet Pattern Row",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PalletPatternColumn",
            "tableName": "IMITEM",
            "label": "Pallet Pattern Column",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PalletPatternHeight",
            "tableName": "IMITEM",
            "label": "Pallet Pattern Height",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PalletSizeCode",
            "tableName": "IMITEM",
            "label": "Pallet Size Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "BoxCode",
            "tableName": "IMITEM",
            "label": "Box Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "HazardousFlag",
            "tableName": "IMITEM",
            "label": "Hazardous Flag",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "CareInstructions",
            "tableName": "IMITEM",
            "label": "Care Instructions",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "SpecificationCode",
            "tableName": "IMITEM",
            "label": "Specification Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ItemSupcCode",
            "tableName": "IMITEM",
            "label": "Item Supc Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "BomExplosionFlag",
            "tableName": "IMITEM",
            "label": "Bom Explosion Flag",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "MiscelleanousFeeFlag",
            "tableName": "IMITEM",
            "label": "Miscelleanous Fee Flag",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "StorageLocationType",
            "tableName": "IMITEM",
            "label": "Storage Location Type",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "StorageLocationPriorityFlag",
            "tableName": "IMITEM",
            "label": "Storage Location Priority Flag",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "SystemCode",
            "tableName": "IMITEM",
            "label": "System Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "AssemblyCode",
            "tableName": "IMITEM",
            "label": "Assembly Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PartCode",
            "tableName": "IMITEM",
            "label": "Part Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "EmCostBucketNumber",
            "tableName": "IMITEM",
            "label": "Em Cost Bucket Number",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "TlFuelTaxFlag",
            "tableName": "IMITEM",
            "label": "Tl Fuel Tax Flag",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "TlFuelTaxCode",
            "tableName": "IMITEM",
            "label": "Tl Fuel Tax Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "DateIntroduced",
            "tableName": "IMITEM",
            "label": "Date Introduced",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "DateAvailable",
            "tableName": "IMITEM",
            "label": "Date Available",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "DateExpiration",
            "tableName": "IMITEM",
            "label": "Date Expiration",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "StorageBillingStartDate",
            "tableName": "IMITEM",
            "label": "Storage Billing Start Date",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "StorageBillingEndDate",
            "tableName": "IMITEM",
            "label": "Storage Billing End Date",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ItemSourceFlag",
            "tableName": "IMITEM",
            "label": "Item Source Flag",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ReorderMethodFlag",
            "tableName": "IMITEM",
            "label": "Reorder Method Flag",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ReorderInventoryMinimumQty",
            "tableName": "IMITEM",
            "label": "Reorder Inventory Minimum Qty",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ReorderInventoryMaximumQty",
            "tableName": "IMITEM",
            "label": "Reorder Inventory Maximum Qty",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ReorderMinimumDaysOnHand",
            "tableName": "IMITEM",
            "label": "Reorder Minimum Days On Hand",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ReorderMaximumDaysOnHand",
            "tableName": "IMITEM",
            "label": "Reorder Maximum Days On Hand",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ReorderQuantityEoqCalculated",
            "tableName": "IMITEM",
            "label": "Reorder Quantity Eoq Calculated",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ReorderQuantityEntered",
            "tableName": "IMITEM",
            "label": "Reorder Quantity Entered",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ReorderQuantityOrderMultiple",
            "tableName": "IMITEM",
            "label": "Reorder Quantity Order Multiple",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ReorderSafetyQuantity",
            "tableName": "IMITEM",
            "label": "Reorder Safety Quantity",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ReorderLeadTime",
            "tableName": "IMITEM",
            "label": "Reorder Lead Time",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "CostBasisMethodFlag",
            "tableName": "IMITEM",
            "label": "Cost Basis Method Flag",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "AverageCost",
            "tableName": "IMITEM",
            "label": "Average Cost",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "StandardCost",
            "tableName": "IMITEM",
            "label": "Standard Cost",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RPriceTable",
            "tableName": "IMITEM",
            "label": "RPrice Table",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "CorePrice",
            "tableName": "IMITEM",
            "label": "Core Price",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "MaximumPriceLevelForDiscount",
            "tableName": "IMITEM",
            "label": "Maximum Price Level For Discount",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "AnniversaryBillingFlag",
            "tableName": "IMITEM",
            "label": "Anniversary Billing Flag",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "AnniversaryBillingDate",
            "tableName": "IMITEM",
            "label": "Anniversary Billing Date",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "AnniversaryBillingQuantity",
            "tableName": "IMITEM",
            "label": "Anniversary Billing Quantity",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "WarrantyFlag",
            "tableName": "IMITEM",
            "label": "Warranty Flag",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "WarrantyPeriodTypeFlag",
            "tableName": "IMITEM",
            "label": "Warranty Period Type Flag",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "WarrantyMonths",
            "tableName": "IMITEM",
            "label": "Warranty Months",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "WarrantyMeterMiles",
            "tableName": "IMITEM",
            "label": "Warranty Meter Miles",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "WarrantyMeterHours",
            "tableName": "IMITEM",
            "label": "Warranty Meter Hours",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode1",
            "tableName": "IMITEM",
            "label": "User Defined Code1",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode2",
            "tableName": "IMITEM",
            "label": "User Defined Code2",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode3",
            "tableName": "IMITEM",
            "label": "User Defined Code3",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode4",
            "tableName": "IMITEM",
            "label": "User Defined Code4",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode5",
            "tableName": "IMITEM",
            "label": "User Defined Code5",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode6",
            "tableName": "IMITEM",
            "label": "User Defined Code6",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode7",
            "tableName": "IMITEM",
            "label": "User Defined Code7",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode8",
            "tableName": "IMITEM",
            "label": "User Defined Code8",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode9",
            "tableName": "IMITEM",
            "label": "User Defined Code9",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode10",
            "tableName": "IMITEM",
            "label": "User Defined Code10",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference1",
            "tableName": "IMITEM",
            "label": "User Defined Reference1",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference2",
            "tableName": "IMITEM",
            "label": "User Defined Reference2",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference3",
            "tableName": "IMITEM",
            "label": "User Defined Reference3",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference4",
            "tableName": "IMITEM",
            "label": "User Defined Reference4",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference5",
            "tableName": "IMITEM",
            "label": "User Defined Reference5",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference6",
            "tableName": "IMITEM",
            "label": "User Defined Reference6",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference7",
            "tableName": "IMITEM",
            "label": "User Defined Reference7",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference8",
            "tableName": "IMITEM",
            "label": "User Defined Reference8",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference9",
            "tableName": "IMITEM",
            "label": "User Defined Reference9",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference10",
            "tableName": "IMITEM",
            "label": "User Defined Reference10",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate1",
            "tableName": "IMITEM",
            "label": "User Defined Date1",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate2",
            "tableName": "IMITEM",
            "label": "User Defined Date2",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate3",
            "tableName": "IMITEM",
            "label": "User Defined Date3",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate4",
            "tableName": "IMITEM",
            "label": "User Defined Date4",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate5",
            "tableName": "IMITEM",
            "label": "User Defined Date5",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate6",
            "tableName": "IMITEM",
            "label": "User Defined Date6",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate7",
            "tableName": "IMITEM",
            "label": "User Defined Date7",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate8",
            "tableName": "IMITEM",
            "label": "User Defined Date8",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate9",
            "tableName": "IMITEM",
            "label": "User Defined Date9",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate10",
            "tableName": "IMITEM",
            "label": "User Defined Date10",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity1",
            "tableName": "IMITEM",
            "label": "User Defined Quantity1",
            "type": "number",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity2",
            "tableName": "IMITEM",
            "label": "User Defined Quantity2",
            "type": "number",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity3",
            "tableName": "IMITEM",
            "label": "User Defined Quantity3",
            "type": "number",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity4",
            "tableName": "IMITEM",
            "label": "User Defined Quantity4",
            "type": "number",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity5",
            "tableName": "IMITEM",
            "label": "User Defined Quantity5",
            "type": "number",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity6",
            "tableName": "IMITEM",
            "label": "User Defined Quantity6",
            "type": "number",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity7",
            "tableName": "IMITEM",
            "label": "User Defined Quantity7",
            "type": "number",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity8",
            "tableName": "IMITEM",
            "label": "User Defined Quantity8",
            "type": "number",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity9",
            "tableName": "IMITEM",
            "label": "User Defined Quantity9",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity10",
            "tableName": "IMITEM",
            "label": "User Defined Quantity10",
            "type": "number",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RGlFund",
            "tableName": "IMITEM",
            "label": "RGl Fund",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ProfileGuid",
            "tableName": "IMITEM",
            "label": "Profile Guid",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LocationClassForwardPick",
            "tableName": "IMITEM",
            "label": "Location Class Forward Pick",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LocationClassReplenishment",
            "tableName": "IMITEM",
            "label": "Location Class Replenishment",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LocationClassReserve",
            "tableName": "IMITEM",
            "label": "Location Class Reserve",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LocationSubclassForwardPick",
            "tableName": "IMITEM",
            "label": "Location Subclass Forward Pick",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LocationSubclassReplenishment",
            "tableName": "IMITEM",
            "label": "Location Subclass Replenishment",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LocationSubclassReserve",
            "tableName": "IMITEM",
            "label": "Location Subclass Reserve",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LocationMaxUnitsForwardPick",
            "tableName": "IMITEM",
            "label": "Location Max Units Forward Pick",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LocationMinUnitsForwardPick",
            "tableName": "IMITEM",
            "label": "Location Min Units Forward Pick",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LocationMinUnitsReplenishment",
            "tableName": "IMITEM",
            "label": "Location Min Units Replenishment",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LocationMaxUnitsReplenishment",
            "tableName": "IMITEM",
            "label": "Location Max Units Replenishment",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PalletReference",
            "tableName": "IMITEM",
            "label": "Pallet Reference",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RHazardous",
            "tableName": "IMITEM",
            "label": "RHazardous",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "OnHand",
            "tableName": "IMITEM",
            "label": "On Hand",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "InOrdered",
            "tableName": "IMITEM",
            "label": "In Ordered",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "OutOrdered",
            "tableName": "IMITEM",
            "label": "Out Ordered",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "InReceiving",
            "tableName": "IMITEM",
            "label": "In Receiving",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "OutShipped",
            "tableName": "IMITEM",
            "label": "Out Shipped",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "InBackOrder",
            "tableName": "IMITEM",
            "label": "In Back Order",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "OutBackOrder",
            "tableName": "IMITEM",
            "label": "Out Back Order",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "InUnavailable",
            "tableName": "IMITEM",
            "label": "In Unavailable",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "OutUnavailable",
            "tableName": "IMITEM",
            "label": "Out Unavailable",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "InFuture",
            "tableName": "IMITEM",
            "label": "In Future",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "OutFuture",
            "tableName": "IMITEM",
            "label": "Out Future",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "Available",
            "tableName": "IMITEM",
            "label": "Available",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "NetAvailable",
            "tableName": "IMITEM",
            "label": "Net Available",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RRateSchedule",
            "tableName": "IMITEM",
            "label": "RRate Schedule",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PopupMessage",
            "tableName": "IMITEM",
            "label": "Popup Message",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LastCost",
            "tableName": "IMITEM",
            "label": "Last Cost",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "InventoryQuantitySource",
            "tableName": "IMITEM",
            "label": "Inventory Quantity Source",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RBuyer",
            "tableName": "IMITEM",
            "label": "RBuyer",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RateSource",
            "tableName": "IMITEM",
            "label": "Rate Source",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RateSelection",
            "tableName": "IMITEM",
            "label": "Rate Selection",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "Size1",
            "tableName": "IMITEM",
            "label": "Size1",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "Size2",
            "tableName": "IMITEM",
            "label": "Size2",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "StorageBilledDateLast",
            "tableName": "IMITEM",
            "label": "Storage Billed Date Last",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "StorageBilledDateNext",
            "tableName": "IMITEM",
            "label": "Storage Billed Date Next",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "MsdsFileName",
            "tableName": "IMITEM",
            "label": "Msds File Name",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RAssociateItem",
            "tableName": "IMITEM",
            "label": "RAssociate Item",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "AssociateDesc",
            "tableName": "IMITEM",
            "label": "Associate Desc",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PriceSource",
            "tableName": "IMITEM",
            "label": "Price Source",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PriceMethod",
            "tableName": "IMITEM",
            "label": "Price Method",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "CalcMethod",
            "tableName": "IMITEM",
            "label": "Calc Method",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PriceLevelA",
            "tableName": "IMITEM",
            "label": "Price Level A",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PriceLevelB",
            "tableName": "IMITEM",
            "label": "Price Level B",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PriceLevelC",
            "tableName": "IMITEM",
            "label": "Price Level C",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PriceLevelD",
            "tableName": "IMITEM",
            "label": "Price Level D",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PriceLevelE",
            "tableName": "IMITEM",
            "label": "Price Level E",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RWarrantyCode",
            "tableName": "IMITEM",
            "label": "RWarranty Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ManagementSource",
            "tableName": "IMITEM",
            "label": "Management Source",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PriceBasis",
            "tableName": "IMITEM",
            "label": "Price Basis",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RFees",
            "tableName": "IMITEM",
            "label": "RFees",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "SubLotUniqueFlag",
            "tableName": "IMITEM",
            "label": "Sub Lot Unique Flag",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RfReceiptValidation",
            "tableName": "IMITEM",
            "label": "Rf Receipt Validation",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RfShipmentValidation",
            "tableName": "IMITEM",
            "label": "Rf Shipment Validation",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "InTransactionNumber",
            "tableName": "IMITEM",
            "label": "In Transaction Number",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "DateLastReceipt",
            "tableName": "IMITEM",
            "label": "Date Last Receipt",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "AcStandardUnitFactor",
            "tableName": "IMITEM",
            "label": "Ac Standard Unit Factor",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "AcStandardWeightFactor",
            "tableName": "IMITEM",
            "label": "Ac Standard Weight Factor",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ItemPayGroup",
            "tableName": "IMITEM",
            "label": "Item Pay Group",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RParticipant",
            "tableName": "IMITEM",
            "label": "RParticipant",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "CommissionBasis",
            "tableName": "IMITEM",
            "label": "Commission Basis",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "CommissionAmount",
            "tableName": "IMITEM",
            "label": "Commission Amount",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RoundingMethod",
            "tableName": "IMITEM",
            "label": "Rounding Method",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RoundingFactor",
            "tableName": "IMITEM",
            "label": "Rounding Factor",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "AlternateStandardCost",
            "tableName": "IMITEM",
            "label": "Alternate Standard Cost",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "AlternateAverageCost",
            "tableName": "IMITEM",
            "label": "Alternate Average Cost",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "AlternateLastCost",
            "tableName": "IMITEM",
            "label": "Alternate Last Cost",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PrevStorageBilledDateLast",
            "tableName": "IMITEM",
            "label": "Prev Storage Billed Date Last",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PrevStorageBilledDateNext",
            "tableName": "IMITEM",
            "label": "Prev Storage Billed Date Next",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RecurringStorage",
            "tableName": "IMITEM",
            "label": "Recurring Storage",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "WebAccessibility",
            "tableName": "IMITEM",
            "label": "Web Accessibility",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "OmKitFlag",
            "tableName": "IMITEM",
            "label": "Om Kit Flag",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PmKitFlag",
            "tableName": "IMITEM",
            "label": "Pm Kit Flag",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "WarrantyFlagShipment",
            "tableName": "IMITEM",
            "label": "Warranty Flag Shipment",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "WarrantyMonthsShipment",
            "tableName": "IMITEM",
            "label": "Warranty Months Shipment",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "CheckMaxDays",
            "tableName": "IMITEM",
            "label": "Check Max Days",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "MaxDays",
            "tableName": "IMITEM",
            "label": "Max Days",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "CheckLotExpiration",
            "tableName": "IMITEM",
            "label": "Check Lot Expiration",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UpdateUomWeight",
            "tableName": "IMITEM",
            "label": "Update Uom Weight",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "AutomaticallyUpdateQuantity",
            "tableName": "IMITEM",
            "label": "Automatically Update Quantity",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LocationAvailableDefault",
            "tableName": "IMITEM",
            "label": "Location Available Default",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LocationReasonCodeDefault",
            "tableName": "IMITEM",
            "label": "Location Reason Code Default",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RItemGroup",
            "tableName": "IMITEM",
            "label": "RItem Group",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ItemSubGroup",
            "tableName": "IMITEM",
            "label": "Item Sub Group",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ItemMember",
            "tableName": "IMITEM",
            "label": "Item Member",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "CheckReceiptDays",
            "tableName": "IMITEM",
            "label": "Check Receipt Days",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "CheckShipmentDays",
            "tableName": "IMITEM",
            "label": "Check Shipment Days",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RImMandatedFees",
            "tableName": "IMITEM",
            "label": "RIm Mandated Fees",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ExpDateBasedOn",
            "tableName": "IMITEM",
            "label": "Exp Date Based On",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "AddToExpDate",
            "tableName": "IMITEM",
            "label": "Add To Exp Date",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode11",
            "tableName": "IMITEM",
            "label": "User Defined Code11",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode12",
            "tableName": "IMITEM",
            "label": "User Defined Code12",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode13",
            "tableName": "IMITEM",
            "label": "User Defined Code13",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode14",
            "tableName": "IMITEM",
            "label": "User Defined Code14",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode15",
            "tableName": "IMITEM",
            "label": "User Defined Code15",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode16",
            "tableName": "IMITEM",
            "label": "User Defined Code16",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode17",
            "tableName": "IMITEM",
            "label": "User Defined Code17",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode18",
            "tableName": "IMITEM",
            "label": "User Defined Code18",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode19",
            "tableName": "IMITEM",
            "label": "User Defined Code19",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedCode20",
            "tableName": "IMITEM",
            "label": "User Defined Code20",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate11",
            "tableName": "IMITEM",
            "label": "User Defined Date11",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate12",
            "tableName": "IMITEM",
            "label": "User Defined Date12",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate13",
            "tableName": "IMITEM",
            "label": "User Defined Date13",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate14",
            "tableName": "IMITEM",
            "label": "User Defined Date14",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate15",
            "tableName": "IMITEM",
            "label": "User Defined Date15",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate16",
            "tableName": "IMITEM",
            "label": "User Defined Date16",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate17",
            "tableName": "IMITEM",
            "label": "User Defined Date17",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate18",
            "tableName": "IMITEM",
            "label": "User Defined Date18",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate19",
            "tableName": "IMITEM",
            "label": "User Defined Date19",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedDate20",
            "tableName": "IMITEM",
            "label": "User Defined Date20",
            "type": "date",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity11",
            "tableName": "IMITEM",
            "label": "User Defined Quantity11",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity12",
            "tableName": "IMITEM",
            "label": "User Defined Quantity12",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity13",
            "tableName": "IMITEM",
            "label": "User Defined Quantity13",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity14",
            "tableName": "IMITEM",
            "label": "User Defined Quantity14",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity15",
            "tableName": "IMITEM",
            "label": "User Defined Quantity15",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity16",
            "tableName": "IMITEM",
            "label": "User Defined Quantity16",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity17",
            "tableName": "IMITEM",
            "label": "User Defined Quantity17",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity18",
            "tableName": "IMITEM",
            "label": "User Defined Quantity18",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity19",
            "tableName": "IMITEM",
            "label": "User Defined Quantity19",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedQuantity20",
            "tableName": "IMITEM",
            "label": "User Defined Quantity20",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference11",
            "tableName": "IMITEM",
            "label": "User Defined Reference11",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference12",
            "tableName": "IMITEM",
            "label": "User Defined Reference12",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference13",
            "tableName": "IMITEM",
            "label": "User Defined Reference13",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference14",
            "tableName": "IMITEM",
            "label": "User Defined Reference14",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference15",
            "tableName": "IMITEM",
            "label": "User Defined Reference15",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference16",
            "tableName": "IMITEM",
            "label": "User Defined Reference16",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference17",
            "tableName": "IMITEM",
            "label": "User Defined Reference17",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference18",
            "tableName": "IMITEM",
            "label": "User Defined Reference18",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference19",
            "tableName": "IMITEM",
            "label": "User Defined Reference19",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedReference20",
            "tableName": "IMITEM",
            "label": "User Defined Reference20",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "WmConsigneeExpDays",
            "tableName": "IMITEM",
            "label": "Wm Consignee Exp Days",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "Reference1",
            "tableName": "IMITEM",
            "label": "Reference1",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "Reference2",
            "tableName": "IMITEM",
            "label": "Reference2",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "Reference3",
            "tableName": "IMITEM",
            "label": "Reference3",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "Reference4",
            "tableName": "IMITEM",
            "label": "Reference4",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "Reference5",
            "tableName": "IMITEM",
            "label": "Reference5",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "UserDefinedComment2",
            "tableName": "IMITEM",
            "label": "User Defined Comment2",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "OversellPercentage",
            "tableName": "IMITEM",
            "label": "Oversell Percentage",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "SaleMaxQuantity",
            "tableName": "IMITEM",
            "label": "Sale Max Quantity",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "RContainerCode",
            "tableName": "IMITEM",
            "label": "RContainer Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ProdCategoryDesc",
            "tableName": "IMITEM",
            "label": "Prod Category Desc",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ProductCategoryCode",
            "tableName": "IMITEM",
            "label": "Product Category Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LocationCode",
            "tableName": "IMITEM",
            "label": "Location Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "WarehouseId",
            "tableName": "IMITEM",
            "label": "Warehouse Id",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "WarehouseName",
            "tableName": "IMITEM",
            "label": "Warehouse Name",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ContainerCode",
            "tableName": "IMITEM",
            "label": "Container Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "Name",
            "tableName": "IMITEM",
            "label": "Name",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "CoreItemUsage",
            "tableName": "IMITEM",
            "label": "Core Item Usage",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ProfileDescription",
            "tableName": "IMITEM",
            "label": "Profile Description",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "PriceCode",
            "tableName": "IMITEM",
            "label": "Price Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "Description",
            "tableName": "IMITEM",
            "label": "Description",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LocationSubclassReplenishmen",
            "tableName": "IMITEM",
            "label": "Location Subclass Replenishmen",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ReorderQuantityEoqCalculate",
            "tableName": "IMITEM",
            "label": "Reorder Quantity Eoq Calculate",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ReorderQuantityOrderMultipl",
            "tableName": "IMITEM",
            "label": "Reorder Quantity Order Multipl",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },

        {
            "name": "Record",
            "tableName": "IMITEM",
            "label": "Record",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "DisableCustomerLookup",
            "tableName": "IMITEM",
            "label": "Disable Customer Lookup",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "ReceiptPutOnHold",
            "tableName": "IMITEM",
            "label": "Receipt Put On Hold",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "HoldReasonCode",
            "tableName": "IMITEM",
            "label": "Hold Reason Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "HoldDaysCount",
            "tableName": "IMITEM",
            "label": "Hold Days Count",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },
        {
            "name": "LotCode",
            "tableName": "IMITEM",
            "label": "Lot Code",
            "type": "text",
            "required": false,
            "visible": false,
            "isLabelChanged": false,
        },

        ]
    }
];

const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "Record",
                "localizedField": "KEYSEQUENCE",
                "tableName": "IMITEM",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "RProfile",
                "localizedField": "R_Profile",
                "tableName": "IMITEM",
                "label": "Profile",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": ItemDpLookupLayout,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RWarehouse",
                "localizedField": "R_WAREHOUSE",
                "tableName": "IMITEM",
                "label": "Warehouse",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IDWarehouseLookupLayout,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ItemCode",
                "tableName": "IMITEM",
                "label": "Item",
                "type": "text",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Description1",
                "tableName": "IMITEM",
                "label": "Description - 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Description2",
                "tableName": "IMITEM",
                "label": "Description - 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RProductCategory",
                "tableName": "IMITEM",
                "label": "Product Category",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IMProductCategoryLookupLayout(),
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "ItemType",
                "tableName": "IMITEM",
                "label": "Item Type",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ItemSourceFlag",
                "tableName": "IMITEM",
                "label": "Item Source",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TaxStatus",
                "tableName": "IMITEM",
                "label": "Tax Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Status",
                "tableName": "IMITEM",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ClassCode",
                "tableName": "IMITEM",
                "label": "Class",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": classCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SubClassCode",
                "tableName": "IMITEM",
                "label": "Sub Class",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": subClassCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "PhysicalCountCode",
                "tableName": "IMITEM",
                "label": "Count Cycle",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": physicalCountCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    }
]
const AdditionalLayout = [
    {
        "groupId": 1,
        "label": "Rate Schedule",
        "fields": [
            {
                "name": "RateSource",
                "tableName": "IMITEM",
                "label": "Rate Source",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RateSelection",
                "tableName": "IMITEM",
                "label": "Rate Selection",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RRateSchedule",
                "tableName": "IMITEM",
                "label": "Rate Schedule",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": ratescheduleCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Stoarge Billing",
        "fields": [
            {
                "name": "StorageBillingStartDate",
                "tableName": "IMITEM",
                "label": "Start",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "StorageBillingEndDate",
                "tableName": "IMITEM",
                "label": "End",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "StorageBilledDateLast",
                "tableName": "IMITEM",
                "label": "Last",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PrevStorageBilledDateLast",
                "tableName": "IMITEM",
                "label": "Previous Last",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "StorageBilledDateNext",
                "tableName": "IMITEM",
                "label": "Next",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PrevStorageBilledDateNext",
                "tableName": "IMITEM",
                "label": "Previous Next",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RecurringStorage",
                "tableName": "IMITEM",
                "label": "Recurring Flag",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "Accounting",
        "fields": [
            {
                "name": "ManagementSource",
                "tableName": "IMITEM",
                "label": "Mgmt Source",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RGLDepartment",
                "tableName": "IMITEM",
                "label": "Department",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": ACDepartmentLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RGLFund",
                "tableName": "IMITEM",
                "label": "GL Fund",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": FAFundLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RCajobCode",
                "tableName": "IMITEM",
                "label": "CA Job",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CAJobLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Miscellaneous Information",
        "fields": [


            {
                "name": "RDestinationId",
                "tableName": "IMITEM",
                "label": "Destination ID",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IDConsigneeLookupLayout({valueExpr:'id',displayExpr:'identityid'}),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RBuyer",
                "tableName": "IMITEM",
                "label": "Buyer",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IDBuyerLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "FreightClassCode",
                "tableName": "IMITEM",
                "label": "Freight Class",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": freightClassCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 5,
        "label": "Receipt Hold/Off Hold",
        "fields": [
            {
                "name": "ReceiptPutOnHold",
                "tableName": "IMITEM",
                "label": "Rec on Hold",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "HoldReasonCode",
                "tableName": "IMITEM",
                "label": "Reason Code",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": holdReasonCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "HoldDaysCount",
                "tableName": "IMITEM",
                "label": "Hold Days",
                "type": "number",
                "format": "#,###",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 6,
        "label": "Popup Message",
        "fields": [

        ]
    },
    {
        "groupId": 7,
        "label": "Location Default",
        "fields": [
            {
                "name": "LocationAvailableDefault",
                "tableName": "IMITEM",
                "label": "Available",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "LocationReasonCodeDefault",
                "tableName": "IMITEM",
                "label": "Available",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": holdReasonCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 8,
        "label": "",
        "fields": [
            {
                "name": "Comment",
                "tableName": "IMITEM",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    }
]
const UOMLayout = [
    {
        "groupId": 1,
        "label": "Inventory Quantity Factors",
        "fields": [
            {
                "name": "InventoryUnitNotUsed",
                "tableName": "IMITEM",
                "label": "Inventory Unit",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "PiecesPerUnitQuantity",
                "tableName": "IMITEM",
                "label": "Pieces/Unit",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UnitsPerPackageQuantity",
                "tableName": "IMITEM",
                "label": "Units/Pkg",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PackagesPerShippingUnitQty",
                "tableName": "IMITEM",
                "label": "Pkg/Ship",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "UOM",
        "fields": [
            {
                "name": "InventoryUnitUom",
                "tableName": "IMITEM",
                "label": "Inventory Unit",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PiecesPerUnitUom",
                "tableName": "IMITEM",
                "label": "Pieces/Unit",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UnitsPerPackageUom",
                "tableName": "IMITEM",
                "label": "Units/Pkg",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PackagesPerShippingUnitUom",
                "tableName": "IMITEM",
                "label": "Pkg/Ship",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "Source",
        "fields": [
            {
                "name": "InventoryQuantitySource",
                "tableName": "IMITEM",
                "label": "Inventory Unit",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "AC Unit Factor",
        "fields": [
            {
                "name": "UnitsPerPackageQuantity",
                "tableName": "IMITEM",
                "label": "Inventory Unit",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 5,
        "label": "Quantity Per Inventory Unit",
        "fields": [
            {
                "name": "UnitVolumeQuantity",
                "tableName": "IMITEM",
                "label": "Unit Volume",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UnitAreaQuantity",
                "tableName": "IMITEM",
                "label": "Unit Area",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UnitValueQuantity",
                "tableName": "IMITEM",
                "label": "Unit Value",
                "type": "number",
                "format": "$ #,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "NetWeightQuantity",
                "tableName": "IMITEM",
                "label": "Unit Net Wt",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "GrossMinusNet",
                "tableName": "IMITEM",
                "label": "Unit Tare Wt",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "GrossWeightQuantity",
                "tableName": "IMITEM",
                "label": "Unit Gross Wt",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 6,
        "label": "UOM",
        "fields": [
            {
                "name": "UnitVolumeUom",
                "tableName": "IMITEM",
                "label": "Unit Volume",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UnitAreaUom",
                "tableName": "IMITEM",
                "label": "Unit Area",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UnitValueUom",
                "tableName": "IMITEM",
                "label": "Unit Value",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "NetWeightUom",
                "tableName": "IMITEM",
                "label": "Unit Net Wt",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 7,
        "label": "Source",
        "fields": [
            {
                "name": "WeightBasisFlag",
                "tableName": "IMITEM",
                "label": "Unit Volume",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 8,
        "label": "AC Wgt Factor",
        "fields": [
            {
                "name": "AcStandardWeightFactor",
                "tableName": "IMITEM",
                "label": "Unit Tare Wt",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 9,
        "label": "",
        "fields": [
            {
                "name": "DateIntroduced",
                "tableName": "IMITEM",
                "label": "Introduced Dt",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DateAvailable",
                "tableName": "IMITEM",
                "label": "Available Dt",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DateExpiration",
                "tableName": "IMITEM",
                "label": "Expiration Dt",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ItemSupcCode",
                "tableName": "IMITEM",
                "label": "Alternate SKU",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "ROemManufactureId",
                "tableName": "IMITEM",
                "label": "Manuf ID",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IDManufacturerLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "OemManufacturerCode",
                "tableName": "IMITEM",
                "label": "OEM Code",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "SpecificationCode",
                "tableName": "IMITEM",
                "label": "Specification",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '05' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PopupMessage",
                "tableName": "IMITEM",
                "label": "Popup Msg",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": popupMessageLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RWarrantyCode",
                "tableName": "IMITEM",
                "label": "Warranty Code",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": WarantyCodesLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RFees",
                "tableName": "IMITEM",
                "label": "Fees",
                "type": "lookup",
                "layout": IMFeesLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RImMandatedFees",
                "tableName": "IMITEM",
                "label": "Mandated Fees",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": MandateFeesLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Comment",
                "tableName": "IMITEM",
                "label": "Comment",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
]
const StatusLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "OnHand",
                "tableName": "IMITEM",
                "label": "On Hand",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "InReceiving",
                "tableName": "IMITEM",
                "label": "In Receiving",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "OutShipped",
                "tableName": "IMITEM",
                "label": "In Shipping",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "OutUnavailable",
                "tableName": "IMITEM",
                "label": "Unavailable",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "Available",
                "tableName": "IMITEM",
                "label": "Available",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "InOrdered",
                "tableName": "IMITEM",
                "label": "Pending Rec",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "OutOrdered",
                "tableName": "IMITEM",
                "label": "Pending Ship",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "NetAvailable",
                "tableName": "IMITEM",
                "label": "Net Available",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "InFuture",
                "tableName": "IMITEM",
                "label": "Future Rec",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "OutFuture",
                "tableName": "IMITEM",
                "label": "Future Ship",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
        ]
    },

    {
        "groupId": 3,
        "label": "Expiration Days on Receipt",
        "fields": [
            {
                "name": "WarrantyFlag",
                "tableName": "IMITEM",
                "label": "Source",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "WarrantyMonths",
                "tableName": "IMITEM",
                "label": "Rec Days",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]
const ReOrderLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "ReorderMethodFlag",
                "tableName": "IMITEM",
                "label": "Method",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "ReorderInventoryMinimumQty",
                "tableName": "IMITEM",
                "label": "Minimum Quantity",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "ReorderInventoryMaximumQty",
                "tableName": "IMITEM",
                "label": "Maximum Quantity",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }
        ]
    },
    {
        "groupId": 4,
        "fields": [
            {
                "name": "ReorderMinimumDaysOnHand",
                "tableName": "IMITEM",
                "label": "Minimum Days",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "ReorderMaximumDaysOnHand",
                "tableName": "IMITEM",
                "label": "Maximum Days",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "ReorderQuantityEntered",
                "tableName": "IMITEM",
                "label": "Entered Qty",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }
        ]
    },
    {
        "groupId": 7,
        "fields": [
            {
                "name": "ReorderQuantityEoqCalculated",
                "tableName": "IMITEM",
                "label": "Calculated Qty",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "ReorderQuantityOrderMultiple",
                "tableName": "IMITEM",
                "label": "Order Multiple",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "ReorderSafetyQuantity",
                "tableName": "IMITEM",
                "label": "Safety Qty",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }
        ]
    },
    {
        "groupId": 9,
        "fields": [
            {
                "name": "ReorderLeadTime",
                "tableName": "IMITEM",
                "label": "Lead Days",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }
        ]
    }
]
const CodesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedCode1",
                "localizedField": "USERDEFINEDCODE_1",
                "tableName": "IMITEM",
                "label": "CODE 2",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '11' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode2",
                "localizedField": "USERDEFINEDCODE_2",
                "tableName": "IMITEM",
                "label": "CODE 2",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '12' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode3",
                "localizedField": "USERDEFINEDCODE_3",
                "tableName": "IMITEM",
                "label": "CODE 3",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '13' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode4",
                "localizedField": "USERDEFINEDCODE_4",
                "tableName": "IMITEM",
                "label": "CODE 4",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '14' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode5",
                "localizedField": "USERDEFINEDCODE_5",
                "tableName": "IMITEM",
                "label": "CODE 5",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '15' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode6",
                "localizedField": "USERDEFINEDCODE_6",
                "tableName": "IMITEM",
                "label": "CODE 6",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '16' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode7",
                "localizedField": "USERDEFINEDCODE_7",
                "tableName": "IMITEM",
                "label": "CODE 7",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '17' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode8",
                "localizedField": "USERDEFINEDCODE_8",
                "tableName": "IMITEM",
                "label": "CODE 8",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '18' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode9",
                "localizedField": "USERDEFINEDCODE_9",
                "tableName": "IMITEM",
                "label": "CODE 9",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '19' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode10",
                "localizedField": "USERDEFINEDCODE_10",
                "tableName": "IMITEM",
                "label": "CODE 10",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '20' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode11",
                "localizedField": "USERDEFINEDCODE_11",
                "tableName": "IMITEM",
                "label": "CODE 11",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: 'B9' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode12",
                "localizedField": "USERDEFINEDCODE_12",
                "tableName": "IMITEM",
                "label": "CODE 12",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: 'C0' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode13",
                "localizedField": "USERDEFINEDCODE_13",
                "tableName": "IMITEM",
                "label": "CODE 13",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: 'C1' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode14",
                "localizedField": "USERDEFINEDCODE_14",
                "tableName": "IMITEM",
                "label": "CODE 14",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: 'C2' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode15",
                "localizedField": "USERDEFINEDCODE_15",
                "tableName": "IMITEM",
                "label": "CODE 15",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: 'C3' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode16",
                "localizedField": "USERDEFINEDCODE_16",
                "tableName": "IMITEM",
                "label": "CODE 16",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: 'C4' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode17",
                "localizedField": "USERDEFINEDCODE_17",
                "tableName": "IMITEM",
                "label": "CODE 17",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: 'C5' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode18",
                "localizedField": "USERDEFINEDCODE_18",
                "tableName": "IMITEM",
                "label": "CODE 18",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: 'C6' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode19",
                "localizedField": "USERDEFINEDCODE_19",
                "tableName": "IMITEM",
                "label": "CODE 19",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: 'C7' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode20",
                "localizedField": "USERDEFINEDCODE_20",
                "tableName": "IMITEM",
                "label": "CODE 20",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: 'C8' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedDate1",
                "localizedField": "USERDEFINEDDATE_1",
                "tableName": "IMITEM",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate2",
                "localizedField": "USERDEFINEDDATE_2",
                "tableName": "IMITEM",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate3",
                "localizedField": "USERDEFINEDDATE_3",
                "tableName": "IMITEM",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate4",
                "localizedField": "USERDEFINEDDATE_4",
                "tableName": "IMITEM",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate5",
                "localizedField": "USERDEFINEDDATE_5",
                "tableName": "IMITEM",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate6",
                "localizedField": "USERDEFINEDDATE_6",
                "tableName": "IMITEM",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate7",
                "localizedField": "USERDEFINEDDATE_7",
                "tableName": "IMITEM",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate8",
                "localizedField": "USERDEFINEDDATE_8",
                "tableName": "IMITEM",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate9",
                "localizedField": "USERDEFINEDDATE_9",
                "tableName": "IMITEM",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate10",
                "localizedField": "USERDEFINEDDATE_10",
                "tableName": "IMITEM",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate11",
                "localizedField": "USERDEFINEDDATE_11",
                "tableName": "IMITEM",
                "label": "Date 11",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate12",
                "localizedField": "USERDEFINEDDATE_12",
                "tableName": "IMITEM",
                "label": "Date 12",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate13",
                "localizedField": "USERDEFINEDDATE_13",
                "tableName": "IMITEM",
                "label": "Date 13",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate14",
                "localizedField": "USERDEFINEDDATE_14",
                "tableName": "IMITEM",
                "label": "Date 14",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate15",
                "localizedField": "USERDEFINEDDATE_15",
                "tableName": "IMITEM",
                "label": "Date 15",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate16",
                "localizedField": "USERDEFINEDDATE_16",
                "tableName": "IMITEM",
                "label": "Date 16",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate17",
                "localizedField": "USERDEFINEDDATE_17",
                "tableName": "IMITEM",
                "label": "Date 17",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate18",
                "localizedField": "USERDEFINEDDATE_18",
                "tableName": "IMITEM",
                "label": "Date 18",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate19",
                "localizedField": "USERDEFINEDDATE_19",
                "tableName": "IMITEM",
                "label": "Date 19",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate20",
                "localizedField": "USERDEFINEDDATE_20",
                "tableName": "IMITEM",
                "label": "Date 20",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedQuantity1",
                "localizedField": "USERDEFINEDQUANTITY_1",
                "tableName": "IMITEM",
                "label": "Quantity 1",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity2",
                "localizedField": "USERDEFINEDQUANTITY_2",
                "tableName": "IMITEM",
                "label": "Quantity 2",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity3",
                "localizedField": "USERDEFINEDQUANTITY_3",
                "tableName": "IMITEM",
                "label": "Quantity 3",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity4",
                "localizedField": "USERDEFINEDQUANTITY_4",
                "tableName": "IMITEM",
                "label": "Quantity 4",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity5",
                "localizedField": "USERDEFINEDQUANTITY_5",
                "tableName": "IMITEM",
                "label": "Quantity 5",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity6",
                "localizedField": "USERDEFINEDQUANTITY_6",
                "tableName": "IMITEM",
                "label": "Quantity 6",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity7",
                "localizedField": "USERDEFINEDQUANTITY_7",
                "tableName": "IMITEM",
                "label": "Quantity 7",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity8",
                "localizedField": "USERDEFINEDQUANTITY_8",
                "tableName": "IMITEM",
                "label": "Quantity 8",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity9",
                "localizedField": "USERDEFINEDQUANTITY_9",
                "tableName": "IMITEM",
                "label": "Quantity 9",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity10",
                "localizedField": "USERDEFINEDQUANTITY_10",
                "tableName": "IMITEM",
                "label": "Quantity 10",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity11",
                "localizedField": "USERDEFINEDQUANTITY_11",
                "tableName": "IMITEM",
                "label": "Quantity 11",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity12",
                "localizedField": "USERDEFINEDQUANTITY_12",
                "tableName": "IMITEM",
                "label": "Quantity 12",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity13",
                "localizedField": "USERDEFINEDQUANTITY_13",
                "tableName": "IMITEM",
                "label": "Quantity 13",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity14",
                "localizedField": "USERDEFINEDQUANTITY_14",
                "tableName": "IMITEM",
                "label": "Quantity 14",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity15",
                "localizedField": "USERDEFINEDQUANTITY_15",
                "tableName": "IMITEM",
                "label": "Quantity 15",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity16",
                "localizedField": "USERDEFINEDQUANTITY_16",
                "tableName": "IMITEM",
                "label": "Quantity 16",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity17",
                "localizedField": "USERDEFINEDQUANTITY_17",
                "tableName": "IMITEM",
                "label": "Quantity 17",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity18",
                "localizedField": "USERDEFINEDQUANTITY_18",
                "tableName": "IMITEM",
                "label": "Quantity 18",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity19",
                "localizedField": "USERDEFINEDQUANTITY_19",
                "tableName": "IMITEM",
                "label": "Quantity 19",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity20",
                "localizedField": "USERDEFINEDQUANTITY_20",
                "tableName": "IMITEM",
                "label": "Quantity 10",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    }
]
const RefrencesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedReference1",
                "localizedField": "USERDEFINEDREFERENCE_1",
                "tableName": "IMITEM",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference2",
                "localizedField": "USERDEFINEDREFERENCE_2",
                "tableName": "IMITEM",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference3",
                "localizedField": "USERDEFINEDREFERENCE_3",
                "tableName": "IMITEM",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference4",
                "localizedField": "USERDEFINEDREFERENCE_4",
                "tableName": "IMITEM",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference5",
                "localizedField": "USERDEFINEDREFERENCE_5",
                "tableName": "IMITEM",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference6",
                "localizedField": "USERDEFINEDREFERENCE_6",
                "tableName": "IMITEM",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference7",
                "localizedField": "USERDEFINEDREFERENCE_7",
                "tableName": "IMITEM",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference8",
                "localizedField": "USERDEFINEDREFERENCE_8",
                "tableName": "IMITEM",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference9",
                "localizedField": "USERDEFINEDREFERENCE_9",
                "tableName": "IMITEM",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference10",
                "localizedField": "USERDEFINEDREFERENCE_10",
                "tableName": "IMITEM",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference11",
                "localizedField": "USERDEFINEDREFERENCE_11",
                "tableName": "IMITEM",
                "label": "Reference 11",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference12",
                "localizedField": "USERDEFINEDREFERENCE_12",
                "tableName": "IMITEM",
                "label": "Reference 12",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference13",
                "localizedField": "USERDEFINEDREFERENCE_13",
                "tableName": "IMITEM",
                "label": "Reference 13",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference14",
                "localizedField": "USERDEFINEDREFERENCE_14",
                "tableName": "IMITEM",
                "label": "Reference 14",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference15",
                "localizedField": "USERDEFINEDREFERENCE_15",
                "tableName": "IMITEM",
                "label": "Reference 15",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference16",
                "localizedField": "USERDEFINEDREFERENCE_16",
                "tableName": "IMITEM",
                "label": "Reference 16",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference17",
                "localizedField": "USERDEFINEDREFERENCE_17",
                "tableName": "IMITEM",
                "label": "Reference 17",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference18",
                "localizedField": "USERDEFINEDREFERENCE_18",
                "tableName": "IMITEM",
                "label": "Reference 18",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference19",
                "localizedField": "USERDEFINEDREFERENCE_19",
                "tableName": "IMITEM",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference20",
                "localizedField": "USERDEFINEDREFERENCE_20",
                "tableName": "IMITEM",
                "label": "Reference 20",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedComment",
                "tableName": "IMITEM",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "UserDefinedComment2",
                "tableName": "IMITEM",
                "label": "Comment 2",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    }
]
const HandlingLayout = [
    {
        "groupId": 1,
        "label": "Location Forward Pick",
        "fields": [
            {
                "name": "LocationClassForwardPick",
                "localizedField": "LOCATIONCLASSFORWARDPICK",
                "tableName": "IMITEM",
                "label": "Class",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '26' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "LocationSubclassForwardPick",
                "localizedField": "LOCATIONSUBCLASSFORWARDPICK",
                "tableName": "IMITEM",
                "label": "Subclass",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '27' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "RLocation",
                "localizedField": "R_LOCATION",
                "tableName": "IMITEM",
                "label": "Loc - Primary",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IMLocationLookupLayout({ moduleType: IM, runtimeParameter }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RLocationBackupForwardPick",
                "localizedField": "R_LOCATIONBACKUPFORWARDPICK",
                "tableName": "IMITEM",
                "label": "Loc - Backup",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IMLocationLookupLayout({ moduleType: IM, runtimeParameter }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "LocationMinUnitsForwardPick",
                "tableName": "IMITEM",
                "label": "Minimum Unit",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "LocationMaxUnitsForwardPick",
                "tableName": "IMITEM",
                "label": "Maximum Unit",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    }, {
        "groupId": 2,
        "label": "Location Replenishment",
        "fields": [
            {
                "name": "LocationClassReplenishment",
                "localizedField": "LocationClassReplenishment",
                "tableName": "IMITEM",
                "label": "Location Replenishment Class",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '26' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "LocationSubclassReplenishment",
                "localizedField": "LocationSubclassReplenishment",
                "tableName": "IMITEM",
                "label": "Location Replenishment Subclass",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '27' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RLocationPrimaryReplenishment",
                "localizedField": "R_LocationPrimaryReplenishment",
                "tableName": "IMITEM",
                "label": "Loc - Primary Replenishment",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IMLocationLookupLayout({ moduleType: IM, runtimeParameter }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RLocationBackupReplenishment",
                "localizedField": "R_LocationBackupReplenishment",
                "tableName": "IMITEM",
                "label": "Loc - Backup Replenishment",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IMLocationLookupLayout({ moduleType: IM, runtimeParameter }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "LocationMinUnitsReplenishment",
                "tableName": "IMITEM",
                "label": "Location Minimum Unit Replenishment",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "LocationMaxUnitsReplenishment",
                "tableName": "IMITEM",
                "label": "Location Maxmimum Unit Replenishment",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    }, {
        "groupId": 3,
        "label": "Location Reserve",
        "fields": [
            {
                "name": "LocationClassReserve",
                "localizedField": "LOCATIONCLASSRESERVE",
                "tableName": "IMITEM",
                "label": "Location Reserve Class",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '26' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "LocationSubclassReserve",
                "localizedField": "LOCATIONSUBCLASSRESERVE",
                "tableName": "IMITEM",
                "label": "Location Reserve Subclass",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '27' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RLocationPrimaryReserve",
                "localizedField": "R_LOCATIONPRIMARYRESERVE",
                "tableName": "IMITEM",
                "label": "Loc - Primary Reserve",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IMLocationLookupLayout({ moduleType: IM, runtimeParameter }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RLocationBackupReserve",
                "localizedField": "R_LOCATIONBACKUPRESERVE",
                "tableName": "IMITEM",
                "label": "Loc - Backup Reserve",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IMLocationLookupLayout({ moduleType: IM, runtimeParameter }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 4,
        "label": "Handling",
        "fields": [
            {
                "name": "CareInstructions",
                "localizedField": "CAREINSTRUCTIONS",
                "tableName": "IMITEM",
                "label": "Instruction",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '06' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "StackHeight",
                "tableName": "IMITEM",
                "label": "Stack Height",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "HazardousFlag",
                "tableName": "IMITEM",
                "label": "Hazarodus",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "RHazardous",
                "tableName": "IMITEM",
                "label": "Haz Mat Code",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": edHazardousLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "FreightClassCode",
                "tableName": "IMITEM",
                "label": "Use Serial #",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '08' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 5,
        "label": "Pallet Building",
        "fields": [
            {
                "name": "PalletReference",
                "localizedField": "PALLETREFERENCE",
                "tableName": "IMITEM",
                "label": "Description",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "PalletSizeCode",
                "tableName": "IMITEM",
                "label": "Size",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "PalletPatternRow",
                "tableName": "IMITEM",
                "label": "Row",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "PalletPatternColumn",
                "tableName": "IMITEM",
                "label": "Column",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "PalletPatternHeight",
                "tableName": "IMITEM",
                "label": "Height",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 6,
        "label": "Material Safety Data Sheet",
        "fields": [
            {
                "name": "MsdsFileName",
                "localizedField": "MSDSFILENAME",
                "tableName": "IMITEM",
                "label": "MSDS File",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]
const KitLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "BomExplosionFlag",
                "tableName": "IMITEM",
                "label": "IM Kit Flag",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "OmKitFlag",
                "tableName": "IMITEM",
                "label": "OM Kit Flag",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "PmKitFlag",
                "tableName": "IMITEM",
                "label": "PM Kit Flag",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RItemKittCode",
                "localizedField": "R_ITEMKITTCODE",
                "tableName": "IMITEM",
                "label": "Kit Code",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IMKitHeaderLookupLayout({ RIdentity: null, ModuleName: IM }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "Description",
                "tableName": "IMITEM",
                "label": "Descripton",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RWarehouse",
                "localizedField": "R_WAREHOUSE",
                "tableName": "IMITEM",
                "label": "Warehouse",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IDWarehouseLookupLayout,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
        ]
    },
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RAssociateItem",
                "tableName": "IMITEM",
                "label": "Item",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": ImItemLookupLayout({ itemType: null, moduleName: IM, runtimeParameter }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "AssociateDesc",
                "tableName": "IMITEM",
                "label": "Associate Description",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
]
const CostPriceLayout = [
    {
        "groupId": 1,
        "label": "Pricing",
        "fields": [
            {
                "name": "PriceSource",
                "tableName": "IMITEM",
                "label": "Price Source",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PriceMethod",
                "tableName": "IMITEM",
                "label": "Price Method",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "PriceBasis",
                "tableName": "IMITEM",
                "label": "Price Basis",
                "type": "number",
                "format": "$#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CalcMethod",
                "tableName": "IMITEM",
                "label": "Calc Method",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PriceLevelA",
                "tableName": "IMITEM",
                "label": "Price Level A",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PriceLevelB",
                "tableName": "IMITEM",
                "label": "Price Level B",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PriceLevelC",
                "tableName": "IMITEM",
                "label": "Price Level C",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PriceLevelD",
                "tableName": "IMITEM",
                "label": "Price Level D",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PriceLevelE",
                "tableName": "IMITEM",
                "label": "Price Level E",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RPriceTable",
                "tableName": "IMITEM",
                "label": "Price Code",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": PriceCodesHeaderLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

        ]
    },
    {
        "groupId": 2,
        "label": "Costing",
        "fields": [
            {
                "name": "CostBasisMethodFlag",
                "tableName": "IMITEM",
                "label": "Cost Basis Method Flag",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "StandardCost",
                "tableName": "IMITEM",
                "label": "Standard Cost",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AverageCost",
                "tableName": "IMITEM",
                "label": "Average Cost",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "LastCost",
                "tableName": "IMITEM",
                "label": "Last Cost",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

        ]
    },
    {
        "groupId": 3,
        "label": "Price Discounts",
        "fields": [
            {
                "name": "ArTradeDiscountFlag",
                "tableName": "IMITEM",
                "label": "Ar Trade Discount Flag",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ArTermsDiscountFlag",
                "tableName": "IMITEM",
                "label": "Ar Terms Discount Flag",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

        ]
    },
    {
        "groupId": 4,
        "label": "Price Rounding",
        "fields": [
            {
                "name": "RoundingMethod",
                "tableName": "IMITEM",
                "label": "Rounding Method",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RoundingFactor",
                "tableName": "IMITEM",
                "label": "Rounding Factor",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

        ]
    }
]
const MiscLayout = [
    {
        "groupId": 1,
        "label": "Commissions Pay Groups",
        "fields": [
            {
                "name": "MinimumSalesQuantity",
                "tableName": "IMITEM",
                "label": "Min Sales Qty",
                "type": "number","format": "#,###",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "SaleIncrementQuantity",
                "tableName": "IMITEM",
                "label": "Sales Multiple",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "ItemPayGroup",
                "tableName": "IMITEM",
                "label": "Item",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: '04' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Brokerage/Consignment Payments",
        "fields": [
            {
                "name": "RParticipant",
                "tableName": "IMITEM",
                "label": "Participant",
                "type": "lookup",
                "layout": IDParticipantLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "CommissionBasis",
                "tableName": "IMITEM",
                "label": "Comm. Basis",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "CommissionAmount",
                "tableName": "IMITEM",
                "label": "Comm. Amount",
                "type": "number","format": "#,###",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 6,
        "label": "Serial Numbers",
        "fields": [
            {
                "name": "ShipSelection",
                "tableName": "IMITEM",
                "label": "Use Serial #",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "AutomaticallyUpdateQuantity",
                "tableName": "IMITEM",
                "label": "Qty Auto Update",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "UpdateUomWeight",
                "tableName": "IMITEM",
                "label": "Update UOM",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Item Grouping",
        "fields": [
            {
                "name": "RItemGroup",
                "tableName": "IMITEM",
                "label": "Item Group",
                "type": "lookup",
                "layout": ItemGroupLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "ItemSubGroup",
                "tableName": "IMITEM",
                "label": "Item Sub Group",
                "type": "lookup","lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: 'B7' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "ItemMember",
                "tableName": "IMITEM",
                "label": "Item Member",
                "type": "lookup","lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: 'B8' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },


    {
        "groupId": 7,
        "label": "Labels",
        "fields": [
            {
                "name": "Reference1",
                "tableName": "IMITEM",
                "label": "Item Ref 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "Reference2",
                "tableName": "IMITEM",
                "label": "Item Ref 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "Reference3",
                "tableName": "IMITEM",
                "label": "Item Ref 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "Reference4",
                "tableName": "IMITEM",
                "label": "Item Ref 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "Reference5",
                "tableName": "IMITEM",
                "label": "Item Ref 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "OversellPercentage",
                "tableName": "IMITEM",
                "label": "Oversell %",
                "type": "number","format": "#,###",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "SaleMaxQuantity",
                "tableName": "IMITEM",
                "label": "Sale Max Qty",
                "type": "number","format": "#,###",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
        {
        "groupId": 3,
        "label": "WEB Settings",
        "fields": [
            {
                "name": "WebAccessibility",
                "tableName": "IMITEM",
                "label": "Accessibility",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
        {
        "groupId": 5,
        "label": "Containers",
        "fields": [
            {
                "name": "RContainerCode",
                "tableName": "IMITEM",
                "label": "Container",
                "type": "lookup",
                "layout": ContainerLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    }
];

export {
    SearchLayout,
    PrimaryLayout,
    AdditionalLayout,
    UOMLayout,
    HandlingLayout,
    StatusLayout,
    CodesLayout,
    RefrencesLayout,
    KitLayout,
    ReOrderLayout,
    CostPriceLayout,
    MiscLayout
}